var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserFill(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.346 4.063c0 2.243-1.879 4.062-4.196 4.062-2.318 0-4.197-1.819-4.197-4.062C3.953 1.819 5.833 0 8.15 0s4.196 1.82 4.196 4.063zM1.017 16c-.61 0-1.093-.483-1.007-1.021.557-3.489 3.922-6.17 7.99-6.17s7.433 2.681 7.99 6.169c.086.54-.396 1.022-1.007 1.022H1.017z",
    fill: "currentColor"
  })));
}
export default SvgUserFill;